import type * as React from 'react';

export type EventHandler = (...args: unknown[]) => unknown;
export type EventHandlers = Record<string, EventHandler>;

export const visuallyHidden: React.CSSProperties = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
};

export function ownerDocument(node: Node | null | undefined): Document {
  return node?.ownerDocument ?? document;
}

export function extractEventHandlers(
  object: Record<string, unknown> | undefined,
  excludeKeys: string[] = [],
): EventHandlers {
  if (!object) {
    return {};
  }

  return Object.keys(object)
    .filter((prop) => /^on[A-Z]/.test(prop) && typeof object[prop] === 'function' && !excludeKeys.includes(prop))
    .reduce<EventHandlers>((handlers, prop) => {
      handlers[prop] = object[prop] as EventHandler;
      return handlers;
    }, {});
}

export function isFocusVisible(element: EventTarget | null): boolean {
  if (!(element instanceof Element)) {
    return false;
  }

  try {
    return element.matches(':focus-visible');
  } catch {
    return false;
  }
}
